module.exports = __webpack_public_path__ + "static/media/chevron-up-down.1f2116d3.svg";